export enum GrowthRateProperties {
  GR = 'growthRate',
  BASE_YEAR = 'baselineYear',
  BASE_CO2 = 'co2',
  BASE_CH4 = 'ch4',
  BASE_N2O = 'n2o',
}

export enum GWPGasses {
  CO2 = 'co2',
  CH4 = 'ch4',
  N2O = 'n2o',
}

export enum ConfigurationSettingsType {
  GWP = 'GWP',
  PROJECTIONS_WITH_MEASURES = 'PROJECTIONS_WITH_MEASURES',
  PROJECTIONS_WITH_ADDITIONAL_MEASURES = 'PROJECTIONS_WITH_ADDITIONAL_MEASURES',
  PROJECTIONS_WITHOUT_MEASURES = 'PROJECTIONS_WITHOUT_MEASURES',
  ANNEX_II_REPORT_CATEGORIES = 'ANNEX_II_REPORT_CATEGORIES',
  SECTOR_YEAR_CONFIGURATION = 'SECTOR_YEAR_CONFIGURATION',
}
